import { render, staticRenderFns } from "./CompraDLM.vue?vue&type=template&id=3488c444&"
import script from "./CompraDLM.vue?vue&type=script&lang=js&"
export * from "./CompraDLM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports